import axios from '@/axios';
import _ from 'lodash';

let accessToken = localStorage.accessToken;
axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

export default {

  namespaced: true,

  actions: {

    async getOrganizations( {commit,rootState} ) {
      try {
        var user_id=rootState.user.id;

        let members = await axios.get(`/user/${user_id}/organizations`);
        commit('SET_ORGANIZATIONS', members.data.data);
      } catch(e) {
        throw(e);
      }
    },

    async getTeamMember( {commit}, organization_id ) {
      if (isNaN(organization_id)) {
        throw "Invalid organization_id";
      }

      try {
        let members = await axios.get(`/organization/${organization_id}/member`);
        commit('SET_CURRENT_TEAM_MEMBER', members.data.data);
      } catch(e) {
        throw(e);
      }
    },

    async getCurrentOrganization( {commit}, {organization_id, user_id}) {
      if (isNaN(organization_id)) {
        throw "Invalid organization_id";
      }

      try {
        let organization = await axios.get(`/user/${user_id}/organization/${organization_id}`);
        commit('SET_CURRENT_ORGANIZATION', organization.data.data);
      } catch(e) {
        throw(e);
      }
    },


    /*BELOW FOR Payment Gateway*/
    async getOrganizationPaymentGateway( {commit,rootState},organization_id ) {
      try {
        let payment_method = await axios.get(`/organization/${organization_id}/payment_method`);
        commit('SET_ORGANIZATION_PAYMENT_METHOD', payment_method.data.data);
        return payment_method.data.data;
      } catch(e) {
        throw(e);
      }
    },

    async getPaymentGateway( {commit,rootState},organization_id ) {
      try {
        let payment_method = await axios.get(`/payment_gateway/active`);
        commit('SET_PAYMENT_GATEWAY', payment_method.data.data);
        return payment_method.data.data;
      } catch(e) {
        throw(e);
      }
    },

    async togglePaymentGatewayStatus( {commit,rootState},data) {
      try {
        let organization_id = data.organization_id;
        let payment_gateway_id = data.payment_gateway_id;
        let status = data.status;
        let payment_method = await axios.patch(`/organization/${organization_id}/payment_method_status`,{ payment_gateway_id: payment_gateway_id,status:status });
        return;
      } catch(e) {
        throw(e);
      }
    },

    async integrateStripe ({ commit }, payload){
      return await axios.post('/stripe/integration', payload)
        .then((res) => {
          return res.data.data;
        })
        .catch((err) => { console.log(err)})
    },

    async integrateCOD ({ commit }, payload){
      return await axios.post(`/organization/${payload.organization_id}/payment_method/cod`,payload)
        .then((res) => {
          return res.data.data;
        })
        .catch((err) => { console.log(err)})
    },

    async integrateFPX ({ commit }, payload){
      return await axios.post(`/organization/${payload.organization_id}/payment_method/fpx`,payload)
        .then((res) => {
          return res.data.data;
        })
        .catch((err) => { console.log(err)})
    },
    async updateDetails( {commit}, { data, organization_id } ) {
      try {
        let res = await axios.put(`/organization/${organization_id}/`, data);
        let org = res.data.data;
        commit('SET_CURRENT_ORGANIZATION', org);
      } catch(e) {
        throw(e);
      }
    },

    async integrateQSPay ({ commit }, payload){
      return await axios.post('/stripe/qspay', payload)
      .then((res) => {
        return res.data.data;
      })
      .catch((err) => { console.log(err)})
    },

    async BankList (){
      let list = [];
      list.push({name:'Al-Rajhi Islamic Bank',value:'Al-Rajhi Islamic Bank'});
      list.push({name:'Affin Bank',value:'Affin Bank'});
      list.push({name:'Affin Islamic',value:'Affin Islamic'});
      list.push({name:'Alliance Bank',value:'Alliance Bank'});
      list.push({name:'AmBank',value:'AmBank'});
      list.push({name:'Bank Islam',value:'Bank Islam'});
      list.push({name:'Bank of China (Malaysia)',value:'Bank of China (Malaysia)'});
      list.push({name:'Bank Muamalat Malaysia Bhd',value:'Bank Muamalat Malaysia Bhd'});
      list.push({name:'Bank Rakyat',value:'Bank Rakyat'});
      list.push({name:'Bank Simpanan Nasional',value:'Bank Simpanan Nasional'});
      list.push({name:'CIMB Bank',value:'CIMB Bank'});
      list.push({name:'Citibank',value:'Citibank'});
      list.push({name:'Hong Leong Bank',value:'Hong Leong Bank'});
      list.push({name:'HSBC Bank',value:'HSBC Bank'});
      list.push({name:'ICBC Malaysia',value:'ICBC Malaysia'});
      list.push({name:'Kuwait Finance House',value:'Kuwait Finance House'});
      list.push({name:'MayBank',value:'MayBank'});
      list.push({name:'MBSB Bank',value:'MBSB Bank'});
      list.push({name:'OCBC Bank',value:'OCBC Bank'});
      list.push({name:'Public Bank',value:'Public Bank'});
      list.push({name:'RHB Bank',value:'RHB Bank'});
      list.push({name:'Standard Chartered Bank',value:'Standard Chartered Bank'});
      list.push({name:'United Overseas Bank',value:'United Overseas Bank'});
      return list;
    },
  },

  getters: {

    team_members(state) {
      return state.current_team_member;
    },
    organization_details(state){
      return state.current_organization;
    },

  },

  mutations: {
    SET_ORGANIZATIONS ( state, payload, rootState) {
      state.organizations = payload;
    },

    SET_CURRENT_TEAM_MEMBER ( state, payload ) {
      state.current_team_member = payload;
    },

    SET_CURRENT_ORGANIZATION(state, payload){
      state.current_organization=payload;
    },

    SET_ORGANIZATION_PAYMENT_METHOD(state, payload){
      state.current_organization_payment_method=payload;
    },

    SET_PAYMENT_GATEWAY(state, payload){
      state.payment_gateway=payload;
    },
  },

  state: {
    organizations: [],
    current_organization: [{
      name: '',
      subdomain: '',
    }], // TODO: dynamic loading
    current_team_member: [],
    current_organization_payment_method: [],
    payment_gateway: '',
  },
}

